<elcia-multi-dropdown [control]="control()"
                      [items]="states()"
                      [label]="'customer.states'"
                      [textField]="'label'"
                      [valueField]="'id'">
</elcia-multi-dropdown>
